export default __webpack_public_path__ + "static/media/1866.74326667.png";